import React, { memo } from 'react';
import { AdjustableComponent } from '../../../../../utils/hooks/useClasses';
import { Button, Modal, ModalBody, ModalHeader } from 'plume-ui';
import FormattedMessage from '../../../../../utils/components/FormattedMessage';

type props = {
  name: string;
  show: boolean;
  callback: (isOutreach: boolean) => void;
};

const MonitorFinishModal: AdjustableComponent<props, {}> = ({
  name,
  show,
  callback,
}) => {
  return (
    <Modal
      fullWidth={true}
      isOpen={show}
      onRequestClose={() => callback(false)}
    >
      <ModalHeader
        title={<FormattedMessage id="monitorAdd.confirmDialog.confirmTitle" />}
      />

      <ModalBody>
        <FormattedMessage
          id={'monitorAdd.confirmDialog.confirmMsg'}
          params={{ monitorName: name }}
        />
      </ModalBody>

      <div className="MonitorAdd__ModalButtonRow">
        <div className="MonitorAdd__ModalButton">
          <Button styleVariant="tertiary" onClick={() => callback(false)}>
            <FormattedMessage id="monitorAdd.confirmDialog.confirmBack" />
          </Button>
        </div>
        <Button styleVariant="superprimary" onClick={() => callback(true)}>
          <FormattedMessage id="monitorAdd.confirmDialog.confirmOutreach" />
        </Button>
      </div>
    </Modal>
  );
};

export default memo(MonitorFinishModal);
